export const environment = {
	production: true,
  url: 'https://api.carrier.kosaas-mmi.com:3001'
};
